import React, { useEffect, useState } from 'react';
import Page, { usePage } from '../../components/Page';
import { useAuth } from '../../units/auth/AuthProvider';
import { Button, Grid, Typography } from '@mui/material';
import { useSideBar } from '../../components/SideBar';
import { useStyles } from '../../hooks/useStyles';
import moment from 'moment';
import { api } from '../../api';
import { TimelineArray } from '../../data/Timeline';
import { useScreenSize } from '../../hooks/useScreenSize';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCalendarClock,
    faCarRear,
    faCars,
    faFileInvoiceDollar,
    faSignIn,
    faSignOut,
    faSquareUser,
} from '@fortawesome/pro-regular-svg-icons';
import { NavigateOptions, To, useNavigate } from 'react-router-dom';
import { grey } from '@mui/material/colors';

export const useHomePage = () => {
    const page = usePage();
    const classes = useStyles();
    const auth = useAuth();
    const screenSize = useScreenSize();
    const navigate = useNavigate();
    const navigateTo = (to: To, options?: NavigateOptions | undefined) => () => navigate(to, options);
    const sideBar = useSideBar();
    const [hasCar, setHasCar] = useState<boolean>(true);
    useEffect(() => {
        api.user.get({ userId: auth.profile.userId, relations: { cars: true } }).then((ret) => {
            if (ret.data && ret.data.length > 0) {
                setHasCar((ret.data[0].cars || []).length > 0);
            }
        });
    }, []);
    return { page, classes, auth, navigate, navigateTo, screenSize, sideBar, hasCar, setHasCar };
};

interface HomePageProps {}

export const HomePage = (homePageProps: HomePageProps): React.ReactElement => {
    const props = useHomePage();
    return (
        <Page {...props.page} title='首頁'>
            <Grid container flexDirection={'row'} height={'100%'}>
                {props.screenSize.mdUp ? (
                    <Grid
                        container
                        item
                        flex={1}
                        flexDirection={'column'}
                        padding={4}
                        sx={{
                            backgroundColor: grey[100],
                            backgroundImage: `url(${require('../../img/bg_2_1.webp')})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'top',
                            backgroundRepeat: 'no-repeat',
                        }}
                    ></Grid>
                ) : (
                    <Grid container item flex={1} flexDirection={'column'} padding={1} sx={{ backgroundColor: grey[100] }}>
                        <Grid container item flexDirection={'row'}>
                            <Grid container item flexDirection={'row'} justifyContent={'flex-end'} xs={12}>
                                {props.hasCar ? (
                                    <Grid container item flexDirection={'row'} xs={12} md={6}>
                                        <Button
                                            fullWidth
                                            size={'large'}
                                            className={props.classes.buttonCyan}
                                            style={{ margin: 4, marginTop: 12, display: 'flex', justifyContent: 'center', gap: 2 }}
                                            onClick={props.navigateTo('/profile')}
                                        >
                                            <FontAwesomeIcon icon={faSquareUser} size={'2x'} fixedWidth />
                                            <Typography variant={'h5'}>{'我的資料'}</Typography>
                                        </Button>
                                    </Grid>
                                ) : (
                                    <Grid container item flexDirection={'row'} xs={12} md={6}>
                                        <Button
                                            fullWidth
                                            size={'large'}
                                            className={props.classes.buttonRed}
                                            style={{ margin: 4, marginTop: 12, display: 'flex', justifyContent: 'center', gap: 2 }}
                                            onClick={props.navigateTo('/profile')}
                                        >
                                            <FontAwesomeIcon icon={faCarRear} size={'2x'} fixedWidth />
                                            <Typography variant={'h5'}>{'綁定車號'}</Typography>
                                        </Button>
                                    </Grid>
                                )}
                                {/* <Grid container item flexDirection={'row'} xs={12} md={6}>
                                    <Button
                                        fullWidth
                                        size={'large'}
                                        className={props.classes.buttonCyan}
                                        style={{ margin: 4, marginTop: 12, display: 'flex', justifyContent: 'center', gap: 2 }}
                                        onClick={props.navigateTo('/reservation')}
                                    >
                                        <FontAwesomeIcon icon={faCalendarClock} size={'2x'} fixedWidth />
                                        <Typography variant={'h5'}>{'候位洗車'}</Typography>
                                    </Button>
                                </Grid> */}
                                <Grid container item flexDirection={'row'} xs={12} md={6}>
                                    <Button
                                        fullWidth
                                        size={'large'}
                                        className={props.classes.buttonCyan}
                                        style={{ margin: 4, marginTop: 12, display: 'flex', justifyContent: 'center', gap: 2 }}
                                        onClick={props.navigateTo('/simple-reservation')}
                                    >
                                        <FontAwesomeIcon icon={faCalendarClock} size={'2x'} fixedWidth />
                                        <Typography variant={'h5'}>{'候位洗車'}</Typography>
                                    </Button>
                                </Grid>
                                <Grid container item flexDirection={'row'} xs={12} md={6}>
                                    <Button
                                        fullWidth
                                        size={'large'}
                                        className={props.classes.buttonCyan}
                                        style={{ margin: 4, marginTop: 12, display: 'flex', justifyContent: 'center', gap: 2 }}
                                        onClick={props.navigateTo('/car-queue-dashboard')}
                                    >
                                        <FontAwesomeIcon icon={faCars} size={'2x'} fixedWidth />
                                        <Typography variant={'h5'}>{'排序看板'}</Typography>
                                    </Button>
                                </Grid>
                                <Grid container item flexDirection={'row'} xs={12} md={6}>
                                    <Button
                                        fullWidth
                                        size={'large'}
                                        className={props.classes.buttonCyan}
                                        style={{ margin: 4, marginTop: 12, display: 'flex', justifyContent: 'center', gap: 2 }}
                                        onClick={props.navigateTo('/price-list')}
                                    >
                                        <FontAwesomeIcon icon={faFileInvoiceDollar} size={'2x'} fixedWidth />
                                        <Typography variant={'h5'}>{'價目表'}</Typography>
                                    </Button>
                                </Grid>
                                <Grid container item flexDirection={'row'} xs={12} md={6}>
                                    <Button
                                        fullWidth
                                        size={'large'}
                                        className={props.classes.buttonCyan}
                                        style={{ margin: 4, marginTop: 12, display: 'flex', justifyContent: 'center', gap: 2 }}
                                        onClick={props.auth.signOut}
                                    >
                                        <FontAwesomeIcon icon={faSignOut} size={'2x'} fixedWidth />
                                        <Typography variant={'h5'}>{'登出'}</Typography>
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </Page>
    );
};
